import { MaterialSlot } from "@/3d/material/MaterialSlot";
import { RawModel } from "@/3d/rawModel/RawModel";
import { useEditorState } from "@/state/editorState";
import _ from "lodash";
import React, { useMemo } from "react";

type MaterialMappingEditorProps = {
    materialSlots: Record<string, MaterialSlot>;
    model: RawModel;
};

export const MaterialMappingEditor = ({ materialSlots, model }: MaterialMappingEditorProps) => {
    const materialNames = useMemo(
        () => _.uniq(model?.meshes.flatMap((mesh) => mesh.materials.map((m) => m.name))),
        []
    );

    const materialMapping = useEditorState((state) => state.materialMapping);
    const setMaterialMapping = useEditorState((state) => state.setMaterialMapping);
    const currentMeshMaterialName = useEditorState((state) => state.currentMeshMaterialName);
    const setCurrentMeshMaterialName = useEditorState((state) => state.setCurrentMeshMaterialName);

    const materialMeshes = useMemo(() => {
        if (!currentMeshMaterialName) {
            return [];
        }

        return model?.meshes.filter((mesh) =>
            mesh.materials.some((material) => material.name === currentMeshMaterialName)
        );
    }, [currentMeshMaterialName]);

    const handleMaterialSlotChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newMapping = { ...materialMapping };
        if (currentMeshMaterialName) {
            if (e.target.value) {
                newMapping[currentMeshMaterialName] = e.target.value;
            } else {
                delete newMapping[currentMeshMaterialName];
            }
            setMaterialMapping(newMapping);
        }
    };

    return (
        <div className="d-flex flex-column gap-2 border-bottom pb-2 mb-2">
            <div>
                Материал модели
                <select
                    className="form-select form-select-sm"
                    value={currentMeshMaterialName}
                    onChange={(e) => setCurrentMeshMaterialName(e.target.value)}
                >
                    <option value="">Select material</option>
                    {materialNames.map((materialName) => (
                        <option key={materialName} value={materialName}>
                            {materialName}
                        </option>
                    ))}
                </select>
            </div>
            {materialMeshes && materialMeshes.length > 0 && (
                <div>
                    <b>Меши</b>
                    {materialMeshes.map((mesh, index) => (
                        <div key={index}>{mesh.name}</div>
                    ))}
                </div>
            )}
            {currentMeshMaterialName && (
                <div>
                    <b>Привязать к</b>
                    <select
                        className="form-select form-select-sm"
                        value={materialMapping[currentMeshMaterialName ?? ""] ?? ""}
                        onChange={handleMaterialSlotChange}
                    >
                        <option value="">Select material slot</option>
                        {Object.values(materialSlots).map((slot) => (
                            <option key={slot.id} value={slot.id}>
                                {slot.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};
